export default __webpack_public_path__ + "static/media/settings.80e20fa6.svg";